import { PageTemplate } from '@ui/templates';
import { InDeveloping } from '@@/common/components/in-developing';
import styles from './index.module.sass';

export function MixingPage() {
  return (
    <PageTemplate header="Миксование" className={styles.root}>
      <InDeveloping />
    </PageTemplate>
  );
}
